"use client";

import { AuthProvider } from "@/components/auth-provider";
import { AuthFocusChecker } from "@/components/auth/auth-focus-checker";
import { AuthModalsManager } from "@/components/auth/auth-modals-manager";
import { AnonymousSubscribeModalPortal } from "@/components/subscriptions/anonymous-signup-modal";
import { PricingModalPortal } from "@/components/subscriptions/pricing-modal";
import { ThemeProvider, ThemeType } from "@/components/theme-provider";
import { ToastListener } from "@/components/toast-listener";
import { Toaster } from "@/components/ui/sonner";
import { PortalContextProvider } from "@/context/portal-context";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { ReactNode } from "react";
import { NavigationProgress } from "./navigation-progress";
import { OfferCountdownProvider } from "./offer-countdown-provider";
import { ReactQueryProvider } from "./react-query-provider";

type ProvidersProps = {
  children: ReactNode;
  defaultTheme?: ThemeType;
};

export function Providers({
  children,
  defaultTheme = "system",
}: ProvidersProps) {
  return (
    <NuqsAdapter>
      <NavigationProgress />
      <ThemeProvider defaultTheme={defaultTheme}>
        <OfferCountdownProvider>
          <PortalContextProvider>
            <ReactQueryProvider>
              <AuthProvider>
                {children}
                <Toaster duration={3000} />
                <ToastListener />
                <AuthModalsManager />
                <AuthFocusChecker />
                <PricingModalPortal />
                <AnonymousSubscribeModalPortal />
              </AuthProvider>
            </ReactQueryProvider>
          </PortalContextProvider>
        </OfferCountdownProvider>
      </ThemeProvider>
    </NuqsAdapter>
  );
}
